export type RequestLog = {
  id: number;
  userId: {
    id: number;
    fullname: string;
    email: string;
  };
  requestId: {
    id: number;
    requestNumber: string;
  };
  action: RequestLogAction;
  entity: string;
  context: string;
  createdAt: string | Date | null;
  private: boolean;
};

export enum RequestLogAction {
  CREATE = 'Create',
  UPDATE = 'Update',
  DELETE = 'Delete',
  NOTIFY = 'Notify',
}

export enum HistoryLogTabs {
  Last15 = 'last15',
  All = 'all',
}

export const HistoryLogTabsTitlesTranslateKeys = {
  [HistoryLogTabs.Last15]: 'last_15',
  [HistoryLogTabs.All]: 'all',
};

export type ComparingLogs = {
  currentLog: string;
  previousLog: string;
};
